export default {
  BLUE: "#13618F",
  ORANGE: "#F06735",
  BLACK: "#101010",
  GRAY_DARKER: "#2E2E2E",
  GRAY_DARK: "#999999",
  GRAY: "#D5D5D5",
  GRAY_LIGHT: "#E7E7E7",
  GRAY_LIGHTER: "#F5F5F5",
  GRAY1: "#303030",
  GRAY2: "#3D3D3D",
  GRAY3: "#414141",
  WHITE: "#FFFFFF",
  GREEN: "#7dbe38",
  RED: "#910A2D",
  RED_DARK: "#770000"
}



// WEBPACK FOOTER //
// ./src/constants/color-palette.js